var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.checked)?_c('div',{staticClass:"checked"},[_c('ts-icon',{attrs:{"icon":"check","size":"xx-small","color":"#000000"}})],1):_vm._e(),(!_vm.checked)?_c('div',{staticClass:"not-checked"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }